export default __webpack_public_path__ + "static/Homepage-Banner-Desktop-Week-2-62980d737e8bde1a231b76e5cf404d21.webp";